import Spinner from './spinner'

Spinner.install = vue => {
  vue.component(Spinner.name, Spinner)
}

export default Spinner
